import Home from './components/Home';

const App = () => (
    <Home />
)

export default App;